export const DEFAULT_IMAGE = `${process.env.REACT_APP_MEDIA_PATH}/openmoji_pot-of-food.png`;
export const LOGO_247WAITER = `${process.env.REACT_APP_MEDIA_PATH}/logo_247waiter.png`;
export const PRODUCT_IMAGE_PATH = '/_upload/products';
export const TEMPLATE_IMAGE_PATH = '/_upload/template';
